
import { language as lan_loginForm } from "./login-form";
import { language as lan_thirdPartyLogin } from "./third-party-login";

let language = {
    ...lan_thirdPartyLogin,
    ...lan_loginForm,

    LOGIN_WELCOME_TEXT: "欢迎使用{{appName}}",
    LOGIN_NEW_TO_SITE_TEXT: " {{appName}}新用户 ?",
    LOGIN_SIGNUP_LINK: "注册 ",
    LOGIN_FORGOT_PASSWORD_LINK: "忘记密码",
};

export { language }